import React from 'react';
import { Divider, Layout, Link } from '@arco-design/web-react';
import { FooterProps } from '@arco-design/web-react/es/Layout/interface';
import cs from 'classnames';
import styles from './style/index.module.less';

function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props;
  return (
    <Layout.Footer className={cs(styles.footer, className)} {...restProps}>
      <Link href="https://beian.miit.gov.cn/" target="_blank">
        蜀ICP备15021446号-2
      </Link>
      <Divider type="vertical" />
      <span>四川省软件行业协会版权所有</span>
    </Layout.Footer>
  );
}

export default Footer;
